import React, { Component } from 'react';
import { array, bool, func, node, object, oneOfType, string } from 'prop-types';
import classNames from 'classnames';
import Card from './Card';
import './ActionableHeaderCard.scss';
import { Toggle } from 'ps-design';

export class ActionableHeaderCard extends Component {
  static propTypes = {
    className: string,
    raised: bool,
    raiseOnHover: bool,
    roundedCorner: bool,
    hoverFocus: bool,
    children: oneOfType([array, object]),
    onCardClick: func,
    onMouseEnter: func,
    onMouseLeave: func,
    cardTitle: oneOfType([string, node]),
    cardHeaderClassName: string,
    cardTitleClassName: string,
    cardActionsClassName: string,
    cardBodyClassName: string,
    isToggleChecked: bool,
    customActionNodes: oneOfType([array, object]),
    isToggleable: bool,
    toggleId: string,
    onToggle: func,
    isCollapsible: bool,
    templateRef: object
  };

  constructor(props) {
    super(props);
    this.state = {
      isCollapsed: false,
      bodyHeight: 0
    };

    this._templateRef = React.createRef();
  }

  static defaultProps = {
    isToggleChecked: true,
    isCollapsible: false
  };

  componentDidMount() {
    const { isCollapsible } = this.props;
    if (isCollapsible) {
      this.setState({ bodyHeight: this.getBodyHeight() });
    }
    this.templateRef = this.props.templateRef || this._templateRef;
    this.setBodyHeight = this.setBodyHeight.bind(this);

    window.addEventListener('resize', this.setBodyHeight);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setBodyHeight);
  }

  componentDidUpdate(prevProps, prevState) {
    this.setBodyHeight();
  }

  setBodyHeight() {
    const { isCollapsible } = this.props;
    if (
      isCollapsible &&
      this.templateRef &&
      this.templateRef.current &&
      this.getBodyHeight() !== this.state.bodyHeight
    ) {
      this.setState({ bodyHeight: this.getBodyHeight() });
    }
  }

  getBodyHeight() {
    const { isCollapsed } = this.state;
    if (this.templateRef && this.templateRef.current) {
      if (isCollapsed) {
        return 0;
      }
      return this.templateRef.current.offsetHeight;
    }
    return 0;
  }

  getToggle() {
    const { isToggleChecked, onToggle, toggleId } = this.props;

    return (
      <Toggle
        id={toggleId}
        onChange={onToggle}
        value={isToggleChecked}
        className="pxl-toggle--modifier-class--csr-card-toggle"
      />
    );
  }

  render() {
    const {
      className,
      raised,
      raiseOnHover,
      roundedCorner,
      hoverFocus,
      onCardClick,
      onMouseEnter,
      onMouseLeave,
      cardTitle,
      cardHeaderClassName,
      cardTitleClassName,
      cardActionsClassName,
      cardBodyClassName,
      isToggleChecked,
      customActionNodes,
      isToggleable,
      toggleId,
      onToggle,
      isCollapsible,
      children
    } = this.props;
    const { isCollapsed } = this.state;
    const cardHeaderClassNames = classNames('card-header__container', cardHeaderClassName, {
      collapsible: isCollapsible && isToggleChecked
    });
    const cardTitleClassNames = classNames('card__title', cardTitleClassName, {
      'card__title--disabled': !isToggleChecked
    });
    const cardActionsClassNames = classNames('card__actions', cardActionsClassName);
    const cardClassNames = classNames(className, {
      'collapsible-card': true
    });
    const cardBodyClassNames = classNames('card__body', cardBodyClassName, {
      collapsed: isCollapsed,
      expanded: !isCollapsed
    });

    return (
      <Card
        className={cardClassNames}
        raised={raised}
        raisedOnHover={raiseOnHover}
        roundedCorner={roundedCorner}
        hoverFocus={hoverFocus}
        onCardClick={onCardClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {(cardTitle || customActionNodes || (isToggleable && toggleId)) && (
          <div
            className={cardHeaderClassNames}
            onClick={() => {
              if (isCollapsible) {
                this.setState({ isCollapsed: !isCollapsed });
              }
            }}
          >
            <div className={cardTitleClassNames}>{cardTitle}</div>
            <div className={cardActionsClassNames}>
              {customActionNodes}
              {isToggleable && toggleId && this.getToggle()}
              {isCollapsible && <i className={isCollapsed ? 'icon-down-open' : 'icon-up-open'} />}
            </div>
          </div>
        )}
        <div className={cardBodyClassNames} style={isCollapsible ? { height: this.state.bodyHeight } : {}}>
          <div ref={this._templateRef}>{children}</div>
        </div>
      </Card>
    );
  }
}

export default ActionableHeaderCard;
